import React from 'react';

import classes from './NavigationItems.css';
import NavigationItem from './NavigationItem/NavigationItem';

const navigationItems = ( props ) => (
    <ul className={classes.NavigationItems}>
        <NavigationItem color={props.color} callBack={props.callBack} link="/" exact toTop fixed >Home</NavigationItem>
        <NavigationItem color={props.color} callBack={props.callBack} link="/#services" fixed >Services</NavigationItem>
        <NavigationItem color={props.color} callBack={props.callBack} link="/#team" fixed >Team</NavigationItem>
        <NavigationItem color={props.color} callBack={props.callBack} link="/#contact" fixed>Contact</NavigationItem>
        <NavigationItem color={props.color} callBack={props.callBack} link="/blog" toTop fixed >Blog</NavigationItem>
        <NavigationItem color={props.color} callBack={props.callBack} type="external" link="https://www.linkedin.com/company/rise-up-luxebmourg">LinkedIn</NavigationItem>
    </ul>
);


export default navigationItems;


// WEBPACK FOOTER //
// ./client/src/components/Navigation/NavigationItems/NavigationItems.js